<template>
  <header
    class="flex justify-between items-center px-4 py-4 absolute top-0 left-0 w-full z-10"
  >
    <!-- Logo -->
    <router-link to="/">
      <div class="flex-shrink-0 mr-8">
        <img
          src="../assets/images/group logo edited2.png"
          alt="Logo"
          class="h-16 hover:scale-105 transition-transform duration-200"
        />
      </div>
    </router-link>

    <!-- Mobile Menu Button -->
    <button @click="toggleMenu" class="md:hidden text-white focus:outline-none">
      <i v-if="!isMenuOpen" class="fa-solid fa-bars text-lg"></i>
      <i v-else class="fa-solid fa-xmark text-lg"></i>
    </button>

    <!-- Navigation -->
    <nav
      class="hidden md:flex items-center justify-between flex-1 text-white font-medium"
    >
      <!-- Center Nav Links -->
      <ul class="flex space-x-8 mx-auto">
        <li>
          <router-link to="/" active-class="font-bold text-yellow">
            Home
          </router-link>
        </li>
        <li>
          <router-link to="/about-us" active-class="font-bold text-yellow">
            About
          </router-link>
        </li>

        <!-- Dropdown -->
        <div
          class="relative group cursor-pointer"
          :class="{ 'font-bold': isCompanyActive }"
        >
          <div
            class="text-white inline-flex items-center transition-all duration-300"
            :class="isCompanyActive ? 'text-yellow' : 'text-white'"
          >
            Our Subsidiaries
            <svg
              class="w-2.5 h-2.5 ms-3"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </div>
          <div
            id="dropdownHover"
            class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
          >
            <ul class="py-3 text-sm text-white">
              <li>
                <router-link
                  to="/mshel-homes"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Homes</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-construction"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Construction</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-prints"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Prints</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-blocks-and-machineries"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Blocks & Machineries</router-link
                >
              </li>
              <li>
                <router-link
                  to="/lisa-suites"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Lisa Suites</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-consult"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Consult</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-foundation"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Foundation</router-link
                >
              </li>
              <li>
                <router-link
                  to="/mshel-logistics"
                  class="block px-4 py-3 hover:bg-white hover:text-black"
                  >Mshel Logistics</router-link
                >
              </li>
            </ul>
          </div>
        </div>

        <!-- <li>
          <router-link to="/the-hub" active-class="font-bold text-yellow"
            >The Hub</router-link
          >
        </li> -->
        <li>
          <router-link to="/services" active-class="font-bold text-yellow"
            >Services</router-link
          >
        </li>
        <li>
          <router-link to="/contact-us" active-class="font-bold text-yellow"
            >Contact Us</router-link
          >
        </li>
      </ul>

      <!-- CTA -->
      <div class="flex space-x-2 items-center ml-auto">
        <a
          role="button"
          href="https://mshelhomes.com/earn-with-us"
          target="_blank"
          class="relative px-8 py-2 text-white bg-yellow transition-all rounded-full border-2 border-transparent"
        >
          <span class="text-base">Invest with us</span>
        </a>
      </div>
    </nav>

    <!-- Mobile Navigation -->
    <transition name="slide">
      <div v-if="isMenuOpen" class="fixed inset-0 z-50 flex">
        <!-- Overlay -->
        <div
          class="fixed inset-0 bg-black opacity-50"
          @click="toggleMenu"
        ></div>

        <!-- Sidebar menu -->
        <div
          class="relative w-72 max-w-full bg-main_blue text-white p-6 shadow-lg z-50 flex flex-col overflow-y-auto"
        >
          <!-- Logo -->
          <div class="mb-6 -ml-5">
            <img
              src="../assets/images/Mshel G  logo.png"
              alt="Logo"
              class="h-24"
            />
          </div>

          <!-- Navigation links -->
          <ul class="space-y-4 -mt-4">
            <li>
              <router-link
                to="/"
                @click="toggleMenu"
                class="block text-sm font-medium hover:text-yellow py-1"
                >Home</router-link
              >
            </li>
            <li>
              <router-link
                to="/about-us"
                @click="toggleMenu"
                class="block text-sm font-medium hover:text-yellow py-1"
                >About</router-link
              >
            </li>

            <!-- Dropdown: Our Companies -->
            <li>
              <div class="group">
                <div
                  class="flex items-center justify-between text-sm font-medium cursor-pointer py-1"
                  @click="toggleDropdownCompany"
                >
                  Our Companies
                  <svg
                    class="w-4 h-4 ml-2 transition-transform duration-200"
                    :class="{ 'rotate-180': isDropdownOpenCompany }"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M1 1l4 4 4-4"
                    />
                  </svg>
                </div>
                <ul v-if="isDropdownOpenCompany" class="mt-2 pl-4 space-y-2">
                  <li>
                    <router-link
                      to="/mshel-homes"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Homes</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-construction"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Construction</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-prints"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Prints</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-blocks-and-machineries"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Blocks & Machineries</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/lisa-suites"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Lisa Suites</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-consult"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Consult</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-foundation"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Foundation</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/mshel-logistics"
                      class="block px-4 py-3 hover:bg-white hover:text-black"
                      >Mshel Logistics</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- <li>
              <router-link
                to="/the-hub"
                @click="toggleMenu"
                class="block text-sm font-medium hover:text-yellow py-1"
                >The Hub</router-link
              >
            </li> -->
            <li>
              <router-link
                to="/services"
                @click="toggleMenu"
                class="block text-sm font-medium hover:text-yellow py-1"
                >Services</router-link
              >
            </li>
            <li>
              <router-link
                to="/contact-us"
                @click="toggleMenu"
                class="block text-sm font-medium hover:text-yellow py-1"
                >Contact Us</router-link
              >
            </li>
          </ul>

          <!-- CTA Button -->
          <div class="mt-12">
            <a
              role="button"
              href="https://mshelhomes.com/earn-with-us"
              target="_blank"
              class="relative px-8 py-2 text-white bg-yellow transition-all rounded-full border-2 border-transparent"
            >
              <span class="text-base">Invest with us</span>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { useRoute } from "vue-router";
export default {
  data() {
    return {
      isMenuOpen: false,
      isDropdownOpenCompany: false,
    };
  },
  computed: {
    route() {
      return useRoute();
    },
    isCompanyActive() {
      return [
        "/mshel-homes",
        "/mshel-construction",
        "/mshel-prints",
        "/mshel-foundation",
        "/lisa-suites",
        "/mshel-consult",
        "/mshel-blocks-and-machineries",
        "/mshel-logistics",
      ].includes(this.route.path);
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdownCompany() {
      this.isDropdownOpenCompany = !this.isDropdownOpenCompany;
    },
  },
};
</script>

<style scoped>
.box {
  position: relative;
  display: inline-block;
  border-radius: 50px;
  padding: 10px 18px;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
